<template>
    <div>

        <home-header :title="i18n('Transportation organization')"></home-header>

        <home-grid schedules pricing transporters></home-grid>

    </div>
</template>

<script>
    import HomeGrid from "../main/HomeGrid";
    import HomeHeader from "../main/HomeHeader";

    export default {
        components: {HomeHeader, HomeGrid}
    }
</script>

<style></style>
